import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = (theme: ExactTheme) =>
  css({
    borderBottom: `1px solid ${theme.colorsV2.blue[50]}`,
    display: "flex",
    gap: 15,
    justifyContent: "space-between",
    paddingLeft: "10px",
    paddingRight: "10px",
    minHeight: "130px",
    position: "relative",
  });

export const totalWrapper = (theme: ExactTheme) => css`
  position: absolute;
  top: 79px;
  width: 100%;
  display: flex;
  align-items: end;
  flex-direction: column;
`;

export const total = (theme: ExactTheme) => css`
  padding-top: 4px;
  border-top: 1px solid ${theme.colorsV2.grey[100]};
  width: 100%;
  text-align: right;
`;

export const totalExplanation = (theme: ExactTheme) => css`
  color: ${theme.colorsV2.grey[600]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const titleColumn = css({
  flexGrow: 1,
  paddingTop: "18px",
});

export const imageColumn = css({
  width: "117px",

  display: "flex",
  alignItems: "center",
  position: "relative",
  flexShrink: 0,
});

export const productNumber = css({
  position: "absolute",
  top: 10,
});

export const image = ({ src }: { src: string }) =>
  css({
    height: "90px",
    width: "100%",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${src})`,
  });

export const counterColumn = css({
  width: "140px",
  flexShrink: 0,
  position: "relative",
});

export const counter = css({
  paddingTop: 35,
});
